import { useState } from "react";
import { Phone, Mail, Star } from "lucide-react";
import Banner from "../assets/images/banner/page_banner.jpg";

const TreatmentFullLayout = ({ data }) => {
  const [lightboxImg, setLightboxImg] = useState(null);
  return (
    <div className="bg-white">

      {/* HERO */}
      <section className="relative h-[420px] flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img
            src={Banner}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/80"></div>
        </div>

        <div className="relative text-center mt-20">
          <h1 className="text-5xl font-black">{data.title}</h1>
          <p className="mt-3 text-lg opacity-90">{data.subtitle}</p>
        </div>
      </section>

      {/* INTRO */}
      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">

          <div>
            <h2 className="text-3xl font-bold mb-4">{data.heading}</h2>
            <p className="text-slate-600 leading-relaxed">
              {data.description}
            </p>
          </div>

          <div>
            <img src={data.image} className="rounded-xl shadow-lg w-full" />
          </div>

        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">

          {data.sections.map((sec, i) => (
            <div key={i} className="mb-14">

              <h3 className="text-2xl font-bold mb-3 text-primary">{sec.title}</h3>
              <p className="text-slate-600 leading-relaxed">{sec.content}</p>

              {/* LIST */}
              {sec.list && (
                <ul className="mt-4 space-y-2 text-slate-700">
                  {sec.list.map((item, idx) => (
                    <li key={idx}>✔ {item}</li>
                  ))}
                </ul>
              )}

              {/* IMAGE */}
              {/* SINGLE IMAGE */}
              {sec.image && !Array.isArray(sec.image) && (
                <div className="mt-6 flex justify-center">
                  <img
                    src={sec.image}
                    alt={sec.title}
                    onClick={() => setLightboxImg(sec.image)}
                    className="rounded-xl shadow-lg max-h-[420px] object-contain bg-white p-3"
                  />
                </div>
              )}

              {/* MULTIPLE IMAGES */}
              {Array.isArray(sec.image) && (
                <div className="mt-6 grid md:grid-cols-2 gap-6">
                  {sec.image.map((img, idx) => (
                    <img
                      key={idx}
                      src={img}
                      alt="treatment"
                      onClick={() => setLightboxImg(img)}
                      className="rounded-xl shadow-lg max-h-[420px] object-contain bg-white p-3 w-full"
                    />
                  ))}
                </div>
              )}

            </div>
          ))}

        </div>
      </section>

      {/* FAQ + FORM */}
      <section className="py-20 bg-lightBg">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10">

          <div>
            <h2 className="text-3xl font-bold mb-6">FAQs</h2>

            {data.faq.map((f, i) => (
              <div key={i} className="bg-white p-5 rounded-xl mb-4 shadow">
                <p className="font-semibold">{f.q}</p>
                <p className="text-slate-600 mt-2">{f.a}</p>
              </div>
            ))}
          </div>

          {/* FORM */}
          <div className="bg-white p-8 rounded-3xl shadow-xl">
            <h3 className="text-xl font-bold mb-4">Book Appointment</h3>

            <input type="text" className="w-full border p-3 rounded mb-3" placeholder="Name" />
            <input type="email" className="w-full border p-3 rounded mb-3" placeholder="Email" />
            <input
              type="tel"
              maxLength="10"
              placeholder="Phone"
              className="w-full border p-3 rounded mb-3"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
              }}
            />
            <textarea rows={3} className="w-full border p-3 rounded mb-3" placeholder="Message" />

            <button className="bg-primary text-white w-full py-3 rounded-xl font-semibold">
              Book Now
            </button>
          </div>

        </div>
      </section>

      {/* CONTACT STRIP */}
      <section className="bg-primary text-white py-8">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-8 text-center">

          <div>
            <Phone className="mx-auto mb-2" />
            <p>Call Us</p>
            <a href="tel:+917774956489">
              <p className="font-bold">+91 77749 56489</p>
            </a>
          </div>

          <div>
            <Mail className="mx-auto mb-2" />
            <p>Email</p>
            <a href="mailto:drsachiturologist@gmail.com">
              <p className="font-bold">drsachiturologist@gmail.com</p>
            </a>
          </div>

          <div>
            <Star className="mx-auto mb-2" />
            <p>Google Rating</p>
            <p className="font-bold">4.8 ★★★★★</p>
          </div>

          <div>
            <button className="bg-white text-primary px-6 py-2 rounded-full font-semibold">
              Book Appointment
            </button>
          </div>

        </div>
      </section>
      {lightboxImg && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          onClick={() => setLightboxImg(null)}
        >
          <img
            src={lightboxImg}
            className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl"
          />
        </div>
      )}
    </div>
  );
};

export default TreatmentFullLayout;